<template>
  <el-dialog
    title="编辑数据"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="增加查看量" prop="viewCount">
        <el-input-number
          v-model="formData.viewCount"
          :min="0"
          controls-position="right"
          placeholder="请输入增加的查看量"
          style="width: 100%"
        />
        <span>原查看量：{{ initialData.viewCount }}</span>
      </el-form-item>

      <el-form-item label="增加收藏量" prop="collectionCount">
        <el-input-number
          v-model="formData.collectionCount"
          :min="0"
          controls-position="right"
          placeholder="请输入增加的收藏量"
          style="width: 100%"
        />
        <span>原收藏量：{{ initialData.collectionCount }}</span>
      </el-form-item>

      <el-form-item :label="publishType == 1 ? '增加意向量' : '增加联系量'" prop="intentionCount">
        <el-input-number
          v-model="formData.intentionCount"
          :min="0"
          controls-position="right"
          placeholder="请输入增加的意向量"
          style="width: 100%"
        />
        <span>原意向量：{{ initialData.intentionCount }}</span>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "PageViewsEditDialog",
  props: {
    // 控制弹窗显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    publishType: {
        default: ''
    },
    // 初始数据，用于编辑时回显
    initialData: {
      type: Object,
      default: () => ({
        viewCount: 0,
        collectionCount: 0,
        intentionCount: 0,
      }),
    },
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        viewCount: 0,
        collectionCount: 0,
        intentionCount: 0,
      },
      rules: {
        viewCount: [
          { required: true, message: "请输入查看量", trigger: "blur" },
          { type: "integer", message: "查看量必须为整数", trigger: "blur" },
        ],
        collectionCount: [
          { required: true, message: "请输入收藏量", trigger: "blur" },
          { type: "integer", message: "收藏量必须为整数", trigger: "blur" },
        ],
        intentionCount: [
          { required: true, message: "请输入意向量", trigger: "blur" },
          { type: "integer", message: "意向量必须为整数", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        // 弹窗打开时，重置表单为 0
        this.formData = {
          viewCount: 0,
          collectionCount: 0,
          intentionCount: 0,
        };
        // 重置表单验证状态
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.clearValidate();
          }
        });
      }
    },
    dialogVisible(val) {
      // 同步父组件的 visible 状态
      this.$emit("update:visible", val);
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // 计算增加后的数据（填写的增量）
          const submitData = {
            viewCount: parseInt(this.formData.viewCount, 10),
            collectionCount: parseInt(this.formData.collectionCount, 10),
            intentionCount: parseInt(this.formData.intentionCount, 10),
          };

          // 触发提交事件，将数据传回父组件
          this.$emit("submit", submitData);
          this.handleClose();
        } else {
          return false;
        }
      });
    },
  },
};
</script>